import { useLocation, useSearchParams } from 'react-router-dom';

interface UseSearchURLParams {
  searchParam: (name: string) => string | null;
}

const useSearchURLParams = (): UseSearchURLParams => {
  const location = useLocation();

  const [paramSearch] = useSearchParams(location.search);

  const searchParam = (name: string) => {
    return paramSearch.get(name);
  };

  return {
    searchParam,
  };
};

export default useSearchURLParams;
